import { TwitterOutlined } from '@ant-design/icons';
import { Alert, Button, Col, Collapse, Image, Layout, Row, Space, Timeline, Typography } from 'antd';
import React, { useEffect } from 'react';
import { Community } from "../components/Community";
import { Footer } from "../components/Footer";
import { Navigation } from "../components/Navigation";
import { DISCORD_LINK, EMAIL, EMAIL_LINK, TWITTER_LINK } from "../Constants";
import * as analytics from "../services/Analytics";
import "./Main.css";

export function Main() {

    useEffect(() => {
        analytics.openMainPage();
    }, []);

    return (
        <Layout>
            <Navigation />
            <Layout.Content className="layout-content">

                {/* Intro */}
                <div className="intro-content" id="intro">
                    <Row justify="space-around" align="middle">
                        <Col lg={{ order: 2, span: 9, offset: 2 }} sm={{ order: 1, span: 24 }}>
                            <Image className='intro-image' src={require("../assets/intro_animation.gif")} preview={false} width={"100%"} />
                        </Col>
                        <Col lg={{ order: 1, span: 13 }} sm={{ order: 2, span: 24 }}>
                            <Space direction='vertical' size='large'>
                                <Typography.Title level={1}>🚀 Crypto Space Prison <span style={{ fontWeight: "100" }}>is a NFT-game created by the Community for Fun</span></Typography.Title>
                                <div>
                                    <Typography.Title level={4} style={{ fontWeight: "300" }}>⚡ Collect prisoners, own prison cells, earn respect tokens</Typography.Title>
                                    <Typography.Title level={4} style={{ fontWeight: "300" }}>🤝 Influence the game with the community</Typography.Title>
                                    <Typography.Title level={4} style={{ fontWeight: "300" }}>🎲 Play mini-games and participate in seasons</Typography.Title>
                                </div>
                                <Button type='primary' size='large' href="/#season_origin">Go to first season</Button>
                            </Space>
                        </Col>
                    </Row>
                </div>

                {/* Season Origin */}
                <div className="layout-content-element" id="season_origin">
                    <Row style={{ margin: "0px 0px 36px 0px" }}>
                        <Col span={24}>
                            <Typography.Title level={1}>🔥 Season «Origin» <span style={{ fontWeight: "100" }}> — Available now!</span></Typography.Title>
                            <Alert
                                message={
                                    <Space direction='vertical'>
                                        <Typography.Text>🚀 This is the first season. Your prisoners haven't been caught yet. Try to escape the space police in a Doodle Jump style mini-game. </Typography.Text>
                                    </Space>
                                }
                                type="info"
                                style={{ width: "100%" }}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={{ order: 1, span: 9, offset: 0 }} sm={{ order: 1, span: 24 }}>
                            <Image className='intro-image' src={require("../assets/season_origin_animation.gif")} preview={false} width={"100%"} />
                        </Col>
                        <Col lg={{ order: 2, span: 13, offset: 1 }} sm={{ order: 2, span: 24 }}>
                            <Space direction='vertical'>
                                <Typography.Paragraph>⚡ 250 unique prisoners from generation «Origin»</Typography.Paragraph>
                                <Typography.Paragraph>🦄 72 traits from standard to super rare</Typography.Paragraph>
                                <Typography.Paragraph>💰 Mint 1 NFT using 0.05 BNB <Typography.Text type='secondary'>(max 5 per wallet address)</Typography.Text></Typography.Paragraph>
                                <Typography.Paragraph>💎 Each prisoner will receive benefits in the next season</Typography.Paragraph>
                                <Typography.Paragraph>🎲 Mini-game where the top 20 players will receive extra benefits in the next season</Typography.Paragraph>
                                <Button type='primary' size='large' href="/dashboard">Mint prisoners</Button>
                            </Space>
                        </Col>
                    </Row>
                </div>

                {/* Season Two */}
                <div className="layout-content-element" id="season_two">
                    <Row style={{ margin: "0px 0px 36px 0px" }}>
                        <Col span={24}>
                            <Typography.Title level={1}>⏳ Season «Two»<span style={{ fontWeight: "100" }}> — Under development</span></Typography.Title>
                            <Alert
                                message={
                                    <Space direction='vertical'>
                                        <Typography.Text>🚀 Season number two. Your prisoners find themselves in a legendary Crypto Space Prison from which it is impossible to escape. </Typography.Text>
                                        <Typography.Text>👊 Try not to die and earn the authority of other prisoners!</Typography.Text>
                                    </Space>
                                }
                                type="info"
                                style={{ width: "100%" }}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={{ order: 1, span: 9, offset: 0 }} sm={{ order: 1, span: 24 }}>
                            <Image className='intro-image' src={require("../assets/season_two_animation.gif")} preview={false} width={"100%"} />
                        </Col>
                        <Col lg={{ order: 2, span: 13, offset: 1 }} sm={{ order: 2, span: 24 }}>
                            <Space direction='vertical'>
                                <Typography.Paragraph>⚡ 1000 unique prisoners from generation «Two»</Typography.Paragraph>
                                <Typography.Paragraph>💰 Mint 1 NFT using 0.25 BNB</Typography.Paragraph>
                                <Typography.Paragraph>🎲 New mini-games</Typography.Paragraph>
                                <Typography.Paragraph>🛰 Unique prison cells with customization features</Typography.Paragraph>
                                <Typography.Paragraph>⭐ Extra features are already being discussed in the community</Typography.Paragraph>
                                <Button type='primary' size='large' href="/dashboard">Go to dashboard</Button>
                            </Space>
                        </Col>
                    </Row>
                </div>

                <div className="layout-content-element" style={{ background: 'transparent' }}>
                    <Space direction='vertical' align="center" style={{ width: "100%", textAlign: "center" }}>
                        <Typography.Title level={1} style={{ margin: "64px 0px 0px 0px", fontStyle: "italic" }}>"</Typography.Title>
                        <Typography.Title level={1} style={{ fontStyle: "italic", maxWidth: "840px" }}>Crypto Space Prison <span style={{ fontWeight: "100" }}>is a game where community and fun come first. We will do our best to keep it that way.</span></Typography.Title>
                        <Typography.Title level={4} style={{ fontWeight: "300" }}>Arthur Sabirzyanov, Founder</Typography.Title>
                        <Typography.Title level={1}><a href="https://twitter.com/kiv1n" target='_blank' rel="noreferrer"><TwitterOutlined /></a></Typography.Title>
                    </Space>
                </div>

                {/* Roadmap */}
                <div className="layout-content-element" id="roadmap">
                    <Space direction='vertical' size="middle">
                        <Typography.Title level={1}>🏔 Roadmap</Typography.Title>
                        <Timeline>
                            <Timeline.Item color="gray">
                                <Typography.Title level={4}>Q4 2021</Typography.Title>
                                <Typography.Paragraph>✅ Creation of the game concept and seasons</Typography.Paragraph>
                                <Typography.Paragraph>✅ Start of development of the season «Origin»</Typography.Paragraph>
                            </Timeline.Item>
                            <Timeline.Item color="gray">
                                <Typography.Title level={4}>Q1 2022</Typography.Title>
                                <Typography.Paragraph>✅ Webapp launch</Typography.Paragraph>
                                <Typography.Paragraph>✅ Season «Origin» release</Typography.Paragraph>
                                <Typography.Paragraph>⚡ Building a community, discussing ideas for next season</Typography.Paragraph>
                                <Typography.Paragraph>⚡ Conducting activities and contests</Typography.Paragraph>
                                <Typography.Paragraph>⚡ Development of the season «Two»</Typography.Paragraph>
                                <Typography.Paragraph>⬜ Team expansion</Typography.Paragraph>
                            </Timeline.Item>
                            <Timeline.Item color="gray">
                                <Typography.Title level={4}>Q2 2022</Typography.Title>
                                <Typography.Paragraph>⬜ Season «Two» release</Typography.Paragraph>
                                <Typography.Paragraph>⬜ Holding a secret event for all prisoner owners</Typography.Paragraph>
                                <Typography.Paragraph>⬜ Start of development of the season «Three»</Typography.Paragraph>
                                <Typography.Paragraph>⬜ Creating a DAO</Typography.Paragraph>
                            </Timeline.Item>
                            <Timeline.Item color="gray">
                                <Typography.Title level={4}>Q3-Q4 2022</Typography.Title>
                                <Typography.Paragraph>⬜ Marketplace launch</Typography.Paragraph>
                                <Typography.Paragraph>⬜ Season «Three» release</Typography.Paragraph>
                                <Typography.Paragraph>⬜ Start of app development for iOS and Android</Typography.Paragraph>
                            </Timeline.Item>
                        </Timeline>
                    </Space>
                </div>

                {/* FAQ */}
                <div className="layout-content-element" id="faq">
                    <Space direction='vertical' style={{ width: "100%" }}>
                        <Typography.Title level={1}>❓ FAQ</Typography.Title>
                        <Collapse defaultActiveKey={['1']}>
                            <Collapse.Panel header="How can I use my prisoner?" key="1">
                                <p>Prisoners are the main character in Crypto Space Prison. </p>
                                <p>You can play with them in mini-games, participate in seasons, earn respect tokens.</p>
                                <p>Only users with prisoners will be able to have prison cells.</p>
                                <p>You can even sell your prisoner if you want.</p>
                            </Collapse.Panel>
                            <Collapse.Panel header="How can I and the community influence the game?" key="2">
                                <p>You will be able to share on our Twitter or Discord any fun idea that you think would be great to add to the game.</p>
                                <p>We will show your idea to the whole community. If people like it, we will try to implement it.</p>
                            </Collapse.Panel>
                            <Collapse.Panel header="How many prisoners will be minted?" key="3">
                                <p>Only 250 prisoners will be minted in the season «Origin». All the other prisoners will be born in other seasons.</p>
                            </Collapse.Panel>
                            <Collapse.Panel header="Why prisoners from season «Origin» are special?" key="4">
                                <p>Only these prisoners will be able to use in mini-game from season «Origin», where the top 20 players will receive extra benefits in the next season.</p>
                            </Collapse.Panel>
                            <Collapse.Panel header="How to mint a prisoner?" key="5">
                                <p>1. Go onto the <a href="/dashboard">dashboard</a> page.</p>
                                <p>2. Connect your Metamask wallet by clicking on the button at the top right corner. Make sure you are connected to the Binance Smart Chain.</p>
                                <p>3. Once your wallet is connected, specify the amount you would like to mint and click on «Mint».</p>
                                <p>4. You will be redirected to confirm and sign your transaction with Metamask.</p>
                                <p>5. Once signed, you will be redirected back.</p>
                                <p>6. Your prisoner will appear on the <a href="/dashboard">dashboard</a> page. Congratulations!</p>
                            </Collapse.Panel>
                            <Collapse.Panel header="What blockchain is used in the game?" key="6">
                                <p>Binance Smart Chain (BSC).</p>
                            </Collapse.Panel>
                            <Collapse.Panel header="What is the address of the smart contract?" key="7">
                                <p>1. Prisoner NFTs (season «Origin») — <a href="https://bscscan.com/address/0x1e4712A93beEc0aa26151CF44061eE91DD56f921" target='_blank' rel="noreferrer">0x1e4712A93beEc0aa26151CF44061eE91DD56f921</a>.</p>
                                <p>2. Leaderboard (season «Origin») — <a href="https://bscscan.com/address/0x96e6af6e9e400d0cd6a4045f122df22bcaaaca59" target='_blank' rel="noreferrer">0x96E6AF6E9e400d0Cd6a4045F122df22BCaAAca59</a>.</p>
                            </Collapse.Panel>
                            <Collapse.Panel header="Do you have more questions?" key="100">
                                <p>
                                    <Typography.Text>If you don’t find an answer to your questions, don’t worry! Join our </Typography.Text>
                                    <Typography.Link href={DISCORD_LINK} target="_blank" onClick={() => analytics.clickOpenDiscord()}>Discord</Typography.Link>
                                    <Typography.Text> or </Typography.Text>
                                    <Typography.Link href={TWITTER_LINK} target="_blank" onClick={() => analytics.clickOpenTwitter()}>Twitter</Typography.Link>
                                    <Typography.Text> and we will be happy to answer any question you may have.</Typography.Text>
                                </p>
                                <p>
                                    <Typography.Text>You can also email us at </Typography.Text>
                                    <Typography.Link href={EMAIL_LINK} target="_blank">{EMAIL}</Typography.Link>
                                    <Typography.Text>.</Typography.Text>
                                </p>
                            </Collapse.Panel>
                        </Collapse>
                    </Space>
                </div>

                <Community />

                <Row justify="center" style={{ margin: "32px 0px 64px 0px" }}>
                    <Col>
                        <Space direction='horizontal'>
                            <Typography.Title level={4}>As seen on:</Typography.Title>
                            <a href='https://nftcalendar.io/event/crypto-space-prison-season-origin/' target='_blank' rel="noreferrer">
                                <Image src={require("../assets/nft-calendar.png")} preview={false} width={"120px"} />
                            </a>
                        </Space>
                    </Col>
                </Row>

                <Footer />

            </Layout.Content>

            <Alert
                className='banner'
                type="warning"
                closable
                icon="✨"
                showIcon={true}
                message={<div>A <a href='/blog'>blog</a> with the latest project news is now available on the site!</div>}
            />

        </Layout >
    )

}